import React, { useEffect, useState } from "react";
import AppShell from "@/components/AppShell";
import { api, errorMessage } from "@/lib/api";

export default function SettingsPage() {
  const [log, setLog] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/admin/notifications");
        setLog(data);
      } catch (e) { setError(errorMessage(e)); }
      finally { setLoading(false); }
    })();
  }, []);

  const statusColor = (s) => s === "sent" ? "text-emerald-700 border-emerald-500/40 bg-emerald-500/10"
    : s === "failed" ? "text-destructive border-destructive/40 bg-destructive/5"
    : "text-muted-foreground border-border bg-accent";

  return (
    <AppShell section="admin">
      <div className="p-6 lg:p-10 max-w-6xl">
        <div className="overline mb-3">Admin Console</div>
        <h1 className="font-display font-black text-3xl lg:text-4xl tracking-tight mb-2">Notifications log</h1>
        <p className="text-[14px] text-muted-foreground mb-8">Recent transactional emails sent by the LMS (last 50).</p>

        {error && <div className="mb-5 p-3 border border-destructive/30 bg-destructive/5 text-destructive text-[13px]">{error}</div>}

        <div className="border border-border bg-white overflow-x-auto">
          {loading ? (
            <div className="p-8 overline">Loading...</div>
          ) : log.length === 0 ? (
            <div className="p-12 text-center text-muted-foreground text-[13px]">No notifications yet.</div>
          ) : (
            <table className="w-full text-[13.5px]">
              <thead>
                <tr className="bg-accent/60 text-[11px] uppercase tracking-wider text-muted-foreground">
                  <th className="text-left p-3 font-semibold">Time</th>
                  <th className="text-left p-3 font-semibold">To</th>
                  <th className="text-left p-3 font-semibold">Subject</th>
                  <th className="text-left p-3 font-semibold">Provider</th>
                  <th className="text-left p-3 font-semibold">Status</th>
                </tr>
              </thead>
              <tbody>
                {log.map((n, i) => (
                  <tr key={i} className="border-t border-border">
                    <td className="p-3 text-muted-foreground font-mono text-[12px]">{n.created_at?.slice(0, 19).replace("T", " ")}</td>
                    <td className="p-3">{n.to}</td>
                    <td className="p-3 text-muted-foreground">{n.subject}</td>
                    <td className="p-3"><span className="sharp-badge">{n.provider}</span></td>
                    <td className="p-3"><span className={`sharp-badge ${statusColor(n.status)}`}>{n.status}</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </AppShell>
  );
}
